import PageLayout from '@/layouts/PageLayout'
import LandingSection from '@/layouts/LandingSection'
import LocationSection from '@/layouts/LocationSection'
import AboutSection from '@/layouts/AboutSection'
import AttendeeSection from '@/layouts/AttendeeSection'
import BreakPatternSection from '@/layouts/BreakPatternSection'
import SEOStructuredData from '@/components/ui/SEOStructuredData'
import SessionsSection from '@/layouts/SessionsSection'
import SpeakersSection from '@/layouts/SpeakersSection'
import PartnersSection from '@/layouts/PartnersSection'
import JobBoardSection from '@/layouts/JobBoardSection'
import OrganizersSection from '@/layouts/OrganizersSection'
import { SpeakersData as Speakers2026 } from '@/data/2026/speakers'
import { partnersData } from '@/data/2026/partners'

import MembersSection from '@/layouts/MembersSection'

function Home() {
  const currentYear = new Date().getFullYear()
  return (
    <PageLayout>
      <SEOStructuredData speakersData={Speakers2026} />
      <h1 id="main-heading" className="sr-only">
        International Women&apos;s Day Innovation Summit {currentYear}
      </h1>

      <LandingSection />

      <div className="bg-iwd-surface-raised relative z-10 space-y-32 py-20 dark:bg-iwd-black-950">
        <LocationSection />

        <div id="schedule">
          <SessionsSection
            speakersData={Speakers2026}
            year={2026}
            tracks={[
              'Map',
              'Schedule',
              'Level Up',
              'Build with AI',
              'AI Foundations',
              'Leadership',
              'Innovation',
              'Careers',
            ]}
          />
        </div>

        <div id="speakers">
          <SpeakersSection speakersData={Speakers2026} />
        </div>

        <div id="about">
          <AboutSection />
        </div>

        <MembersSection />
        <AttendeeSection />
        <BreakPatternSection />

        <div id="jobboard">
          <JobBoardSection />
        </div>

        <div id="partners">
          <PartnersSection partnersData={partnersData} year={currentYear} />
        </div>

        <div id="team">
          <OrganizersSection />
        </div>
      </div>
    </PageLayout>
  )
}

export default Home
